var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 46c12.035 0 22-9.986 22-22 0-12.035-9.986-22-22.022-22C11.965 2 2 11.965 2 24c0 12.014 9.986 22 22 22m-2.437-11.453c-.734 0-1.337-.302-1.898-1.057l-5.414-6.643c-.323-.431-.518-.906-.518-1.402 0-.97.755-1.768 1.726-1.768.625 0 1.1.194 1.639.905l4.379 5.651 9.21-14.796c.41-.647.97-.992 1.53-.992.95 0 1.834.647 1.834 1.66 0 .475-.28.971-.54 1.424L23.375 33.49c-.452.712-1.078 1.057-1.811 1.057"
  })));
};
export default SvgTick;